import RewardsBazaarModal from 'components/GlobalModals/RewardsBazaarModal/RewardsBazaarModal';
import { withRewardsBazaarModalProps } from 'viewModel/rwdBasket/RewardsBazaarModal/withRewardsBazaarModalProps';
const ConnectedRewardsBazaarModalProps = withRewardsBazaarModalProps(RewardsBazaarModal);

export default ConnectedRewardsBazaarModalProps;
